import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_CV = "GET_LIST_CV";
export const GET_DETAIL_CV = "GET_DETAIL_CV";
export const DELETE_CV = "DELETE_CV";
export const SET_LIST_CV = "SET_LIST_CV";
export const SET_DETAIL_CV = "SET_DETAIL_CV";


const state = {
    cv: [],
    cvDetail: {}
};

const getters = {
    cv(state) {
        return state.cv;
    },
    cvDetail(state) {
        return state.cvDetail;
    },


};
const actions = {
    [GET_LIST_CV](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_CV}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_CV, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_CV](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CV}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CV, data);
                }
                resolve(data);
            });
        });
    },
    [DELETE_CV](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_CV}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_CV](state, data) {
        state.cv = data.data;
    },
    [SET_DETAIL_CV](state, data) {
        state.cvDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};